<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-title> Checkout </ion-title>
  </ion-toolbar>
</ion-header>
<ion-progress-bar type="indeterminate" *ngIf="isLoading"></ion-progress-bar>
<ion-content>
  <ion-accordion-group
    expand="inset"
    [multiple]="true"
    [value]="['summary', 'payments']"
  >
    <ion-accordion value="summary">
        <ion-item slot="header">
          <ion-label>Order Summary</ion-label>
        </ion-item>
        <div class="ion-padding" slot="content">
          <ion-list *ngIf="displayRequest">
            <ion-list-header mode="ios">Products</ion-list-header>
            <ion-item *ngFor="let product of displayRequest.products">
              <ion-label
                >{{ product.quantity }} - {{ product.displayName }}</ion-label
              >
              <ion-label slot="end">{{
                product.amount | currency: "USD" : "symbol" : "1.0"
              }}</ion-label>
            </ion-item>
            <ion-item
              *ngIf="
                !displayRequest.products || displayRequest.products.length == 0
              "
              >No items selected.</ion-item
            >

            <ion-list-header mode="ios">Order Summary</ion-list-header>

            <ion-item>
              <ion-label>Subtotal</ion-label>
              <ion-label slot="end">{{
                (displayRequest.subtotal || 0) / 100
                  | currency: "USD" : "symbol" : "1.2"
              }}</ion-label>
            </ion-item>

            <ion-item
              *ngIf="displayRequest.feeTotal > 0"
              (click)="showFees = !showFees"
            >
              <ion-label
                >Transaction Fees
                <small style="cursor: pointer">(see more)</small></ion-label
              >
              <ion-label slot="end">{{
                displayRequest.feeTotal / 100
                  | currency: "USD" : "symbol" : "1.2"
              }}</ion-label>
            </ion-item>

            <ng-container *ngIf="displayRequest.fees && showFees">
              <ion-item>
                <!--extra padding-->
                <ion-list style="width: 100%">
                  <ion-item
                    *ngFor="let fee of displayRequest.fees"
                    [class.strikethrough]="!fee.isActive"
                  >
                    <ion-label>{{ fee.displayName }}</ion-label>
                    <ion-label slot="end" *ngIf="!fee.isPercentage">{{
                      fee.feeAmount | currency: "USD" : "symbol" : "1.0"
                    }}</ion-label>
                    <ion-label slot="end" *ngIf="fee.isPercentage"
                      >{{ fee.feeAmount * 100 }}%</ion-label
                    >
                  </ion-item>
                </ion-list>
              </ion-item>
            </ng-container>

            <ion-item>
              <ion-label><b>Total</b></ion-label>
              <ion-label slot="end" style="font-weight: bolder">{{
                (displayRequest.total || 0) / 100
                  | currency: "USD" : "symbol" : "1.2"
              }}</ion-label>
            </ion-item>
          </ion-list>
        </div>
    </ion-accordion>

    <ion-accordion value="payments">
      <ion-item slot="header">
        <ion-label>Payment Details</ion-label>
      </ion-item>
      <div class="ion-padding" slot="content">
        <ion-list *ngIf="displayRequest && payForm" [formGroup]="payForm">
          <ion-item>
            <ion-label>Name</ion-label>
            <ion-input formControlName="name"></ion-input>
          </ion-item>
          <ion-item>
            <ion-label>Amount $</ion-label>
            <ion-input readonly formControlName="amount" type="number"></ion-input>
          </ion-item>
        </ion-list>
  
        <ng-container *ngIf="displayRequest && displayRequest.total > 0">
          <ion-card-title style="margin-top: 1rem"
            >Payment Method</ion-card-title
          >
          <ion-badge
            style="cursor: pointer; margin: 0.25rem 1rem 0 0"
            color="success"
            (click)="editPayMethods = false; addPayMethod = !addPayMethod"
            >{{
              addPayMethod
                ? "Use saved payment method"
                : "Add new payment method"
            }}</ion-badge
          >
          <app-stripe-customer-payment-methods
            *ngIf="!addPayMethod"
            [hideAddNewPayment]="true"
            [accountId]="request.accountId"
            [isTest]="isTestPayment"
            (paymentMethodSelected)="selectedPaymentMethodId = $event?.id"
          ></app-stripe-customer-payment-methods>
  
          <div
            style="padding: 1rem"
            *ngIf="
              stripeKeys &&
              stripeKeys.paymentIntentClientSecret &&
              addPayMethod
            "
          >
            <ngx-stripe-payment
              [appearance]="appearance"
              [clientSecret]="stripeKeys.paymentIntentClientSecret"
            ></ngx-stripe-payment>
          </div>
        </ng-container>
      </div>
    </ion-accordion>
  </ion-accordion-group>
  
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-buttons>
      <ion-button color="danger" (click)="close(null)">Cancel</ion-button>

      <ion-button
        style="margin-left: auto; padding-right: 15px; min-width: 200px;"
        fill="solid"
        color="success"
        (click)="completeOrder()"
        >{{ displayRequest?.total > 0 ? 'Pay ' + (payForm.value.amount | currency) : 'Save' }}</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
